<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_kartlari"  url="CreateBrandSupplierScorecard" :show_button="true" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<template v-if="items.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>

</div>
</template>
<template v-else>


<ContentTable :data="items" :columns="columns" identifier_row_name="card_id" routename="BrandSupplierScorecard" deleteobjectname="supplier_scorecard" @dataDeleted="getData"></ContentTable>
</template>

</template>

</div>
</template>

<script>
export default {

  name: 'BrandSupplierScorecards',

 data () {
    return {
      items:[],
      loading:true,
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
        multilingual:false,
      },
      {
        type:"boolean",
        field:"active",
        header:"aktif",
        hide_on_mobile:false,
      },
      {
        type:"boolean",
        field:"share_with_suppliers",
        header:"tedarikcilerle_paylas",
        hide_on_mobile:false,
      },
      ]
    }
  },
   mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("get_supplier_scorecards/"+this.$route.params.id)
        console.log(this.items)
        this.loading = await false
    },    
  }
}
</script>

<style lang="css" scoped>
</style>